import React, { FC, PropsWithChildren, useEffect } from 'react';
import { MsalProvider, useMsal } from '@azure/msal-react';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react';

import { getMsalInstance } from '@/lib/auth/msal';
import { LoadingFullScreen } from '../helpers/loading';
import {
  AZURE_API,
  AZURE_CLIENT_ID,
  AZURE_TENANT_ID,
  REDIRECT_URL,
} from '@/lib/env';
import { isMfeMode } from '@/mfe/mfe-mode';

const SignIn = () => {
  const { instance, accounts, inProgress } = useMsal();

  useEffect(() => {
    if (accounts.length > 0 && !instance.getActiveAccount()) {
      instance.setActiveAccount(accounts[0]);
    }
  }, [accounts, instance]);

  useEffect(() => {
    if (instance.getAllAccounts().length === 0 && inProgress === 'none') {
      instance.loginRedirect({ scopes: [AZURE_API] });
    }
  }, [instance, accounts, inProgress]);

  return null;
};

const Authentication: FC<PropsWithChildren> = ({ children }) => {
  if (isMfeMode()) {
    return <>{children}</>;
  }

  const msalInstance = getMsalInstance(
    AZURE_CLIENT_ID,
    AZURE_TENANT_ID,
    REDIRECT_URL
  );

  return (
    <MsalProvider instance={msalInstance}>
      <SignIn />

      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <LoadingFullScreen />
      </UnauthenticatedTemplate>
    </MsalProvider>
  );
};

export default Authentication;
